import {setId} from 
    "./../universal_methods/setId.js";

import {getId} from 
    "./../universal_methods/getId.js";        
import {isEmpty} from "./../universal_methods/isEmpty.js";  
import {getAttributes} from "./../universal_methods/getAttributes.js";  

import {render} from "./methods/render.js";
import {events} from "./methods/events.js";
import {valueHasChanged} from "./methods/valueHasChanged.js";
import {changeMinimumValue} from "./methods/changeMinimumValue.js";
import {changeMaximumValue} from "./methods/changeMaximumValue.js";
import {changeValue} from "./methods/changeValue.js";



export class SmetioRangeSlider {

    constructor(){
    
        this.setId = setId;
        this.getId = getId;
        this.getAttributes = getAttributes;
        this.isEmpty = isEmpty;
        this.render = render;
        this.events = events;
        this.valueHasChanged = valueHasChanged;
        this.changeMinimumValue = changeMinimumValue;
        this.changeMaximumValue = changeMaximumValue;
        this.changeValue = changeValue;

        this.setId();
        //this.getId();

        this.withOutEditableTextInput = false;
        this.withOutResetBtn = false;
        this.min = 0;
        this.max = 100;
        this.minText = this.min;
        this.maxText = this.max;
        this.defaultValue = 50;
        this.sliderText = "";
        this.onChangeFunc = "";
        this.property = "";
        this.unit = "";

        /***** 
         * IS AN OBJECT THAT CAN BE USED BY OTHER FUNCTIONS TO STORE THE DETAILS THAT ARE PASSED 
         * TO THE this.onChangeFunc
         * 
         * THIS COULD BE A LOCAL VARIABLES OBJECT WITHIN A FUNCTION OR ANOTHER CLASS 
         * 
         * OBJECTS ARE PASSED BY REFERENCE AND THIS MEANS THE CONTENT OF THE this.storageObj
         * WILL THEN BE AVAILABLE TO OTHER PARTS/FUNCTIONS OF THE CLASS
         * 
         * FOR EXAMPLE ONE PASSES this.test AS storageObj, IF storageObj["isOpen"] = true THEN 
         * this.test["isOpen"] IS ALSO EQUAL TO true 
         * 
         *  ****/ 
        this.storageObj = {};


        this.mainDivClass = "smetio-ui-rangeSlider-"+this.id;

        this.mainAttributes = {

             class:["smetio-ui-rangeSlider", this.mainDivClass],

        };

        this.rangeInputClass = "smetio-ui-rangeSlider-rangeInput-"+this.id;
        this.rangeInputAttributes = {
 
            class:["smetio-ui-rangeSlider-rangeInput", this.rangeInputClass],
            type: "range"
        };

        this.editableInputClass = "smetio-ui-rangeSlider-editableInput-"+this.id;
        this.editableInputAttributes = {

            class:["smetio-ui-rangeSlider-editableInput", this.editableInputClass],
            type: "text",
            hidden: this.withEditableTextInput

        };

        this.resetBtnClass = "smetio-ui-rangeSlider-resetBtn-"+this.id;
        this.resetBtnAttributes = {

            class:["smetio-ui-rangeSlider-resetBtn", this.resetBtnClass],
            hidden:this.withOutResetBtn

        };

        this.minTextClass = "smetio-ui-rangeSlider-miniText-"+this.id;
        this.minTextAttributes = {

            class:[
                "smetio-ui-rangeSlider-miniText", 
                this.minTextClass

            ]
  
        };        

        this.maxTextClass = "smetio-ui-rangeSlider-maxText-"+this.id;
        this.maxTextAttributes = {

            class:[
                "smetio-ui-rangeSlider-maxText", 
                this.maxTextClass

            ]
  
        }; 


    };

};
